import { render, staticRenderFns } from "./IntegrationHeader.vue?vue&type=template&id=648dc703&"
import script from "./IntegrationHeader.vue?vue&type=script&lang=js&"
export * from "./IntegrationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports